@if (tabs) {
  <div class="text-center text-secondary border-b border-slate-200 dark:border-dark-border">
    <ul class="flex flex-wrap -mb-px">
      @for (tab of tabs; track i; let i = $index) {
        <li class="me-2">
          <a
            href="#"
            class="text-sm font-medium inline-block p-4 text-secondary border-b-2 border-transparent hover:border-slate-400 dark:hover:border-dark-border-light hover:text-primary"
            [ngClass]="{ 'text-theme-primary !border-theme-primary active hover:text-theme-primary': activeTab == i }"
            [attr.aria-current]="activeTab == i"
            (click)="$event.preventDefault(); activateTab(tab)"
          >
            {{ (tab.title || '-') | translate }}
          </a>
        </li>
      }
    </ul>
  </div>
  @if (tabs.length > 0) {
    <div>
      <ng-content></ng-content>
    </div>
  }
}

